import { makeResource } from '@/lib/api/resources';
import { api } from '@/lib/api/client';
import type { BlockSchemaRegistry, ContentItem } from '@/lib/api/types';

/** One resource client per collection key, base `/admin/{collection}` (spec §9.3). */
export function contentResource(collection: string) {
  return makeResource<ContentItem>(`/admin/${collection}`);
}

/**
 * Collection `doc` JSON Schemas (GET /admin/collection-schemas). The backend owns the
 * canonical shape of each collection's rich `doc`; the content editor is generated from
 * the matching entry (industry/project/article/job) so the form, server validation, and
 * the public site never drift. Collections without a backend entry fall back to the static
 * registry in `@/config/collections`.
 */
export function collectionSchemas(): Promise<BlockSchemaRegistry> {
  return api.get<BlockSchemaRegistry>('/admin/collection-schemas');
}
